import { useState } from "react";
import Modal from "../modal/modal";
import { useForm } from "react-hook-form";
import { LoginFormValues } from '@erpsquad/common/runtime';
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { useAuth } from '@erpsquad/common/runtime';
import { styled } from '@mui/material';
import { Box } from "@mui/material";
import Typography from "../typography/typography";
import DynamicInput from "../form-control/form-builder/form-builder-element/text";
import { Eye, EyeOff } from "../icons";
import Button from "../button/button";
import Toast from "../toast/toast";
import { Checkbox, FormControlLabel } from "@mui/material";


const validationSchema = Yup.object({
  login: Yup.object({
      password: Yup.string()
                .required("Please enter password")
                .min(8, "Password must be at least 8 characters")
                .matches(/[A-Z]/, "Password must contain at least one uppercase letter")
                .matches(/[!@#$%^&*(),.?":{}|<>]/, "Password must contain at least one special character"),
  }),
});



const ChangeUserPasswordModal = ({showModal, setShowModal, userId}) => {
     const { changeUserPasswordByAdmin } = useAuth();
     const [isNotify, setIsNotify] = useState(false);
    const [toast, setToast] = useState<IToast | null>(null);

    interface FormValeus {
        login: LoginFormValues;
    }

    const { control, handleSubmit, reset, trigger } = useForm<FormValeus>({
      resolver: yupResolver(validationSchema),
      mode: "all",
    });

    const onSubmit = async (values: FormValeus) => {
        const isValid = await trigger();
        if (!isValid) return;
        values.login.id = userId;
        values.login.isNotify = isNotify;
      await changeUserPasswordByAdmin(values.login, (message, type) => {
        if (type) {
          setToast({ message: message, type: "normal" });
          setShowModal(false);
          reset({
            login: {
                password: "",
                id: "",
                isNotify: false
            },
        });
        } else {
          setToast({ message: message, type: "alert" });
        }
      });
      return values;      
    };

    const [showPassword, setShowPassword] = useState<boolean>(false);
    const handleShowPassword = () => setShowPassword(!showPassword);

     const FlexBox = styled(Box)(() => ({
        display: "flex",
        flexDirection: "column",
    }));

    return (
        <>
        <Modal 
        open={showModal}
        onClose={() => setShowModal(false)} 
        children={
          <>
            <form onSubmit={handleSubmit(onSubmit)}>
                <FlexBox gap={4} className="popup-change-pass">
                  <FlexBox gap={2}>
                    <Box>
                      <Typography
                        align="center"
                        type="h1"
                        weight="medium"
                        color="theme.secondary.1000"
                      >
                        Change Password
                      </Typography>
                    </Box>
                    <FlexBox gap={2}>
                      <Box>
                        <DynamicInput
                          formControl={control}
                          label="Enter New Password"
                          name="password"
                          type={showPassword ? "text" : "password"}
                          placeholder="Enter New Password"
                          fieldArrayName="login"
                          endIcon={
                            <>
                              {showPassword ? (
                                <Eye fontSize="small" htmlColor="#292D32" />
                              ) : (
                                <EyeOff fontSize="small" htmlColor="#292D32" />
                              )}
                            </>
                          }
                          onIconClick={handleShowPassword}
                        />
                      </Box>
                      <Box>
                        <FormControlLabel  control={<Checkbox size="small" onChange={(e) => setIsNotify(e.target.checked)} sx={{
                            '&.Mui-checked': {
                            color: '#2EB273',
                            },
                        }} />} label="Notify User of Password Change" sx={{ 
                            '& .MuiFormControlLabel-label': {
                            fontSize: '14px',
                            },
                        }}/>
                      </Box>
                    </FlexBox>
                  </FlexBox>
                  <FlexBox gap={2}>
                    <Button type="button" onClick={handleSubmit(onSubmit)} size="large" variant="contained">
                      Change Password
                    </Button>
                  </FlexBox>
                </FlexBox>
              </form>          
          </>
        }
        />
        <Toast
            open={Boolean(toast)}
            message={toast?.message}
            type={toast?.type}
            handleClose={() => setToast(null)}
            anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
            autoHideDuration={3000}
            />
        </>
    );
}

export { ChangeUserPasswordModal };
export default ChangeUserPasswordModal;